import React, { Component } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import { isEmpty } from 'lodash';
import moment from 'moment';
import PageTitle from '../../../../components/PageTitle';
import RouteNames from '../../../App/RouteNames';
import { uploadMultiPartFiles, saveOutputTemplateByType, getOutputTemplateByType } from '../../../App/actions';
import TitleFrom from '../../../../components/common/TitleFrom';
import { UnbilledTransactionsSearchForm } from '../../../../components/ReportHub';
import {
  SwitchExport,
  DataTable,
  ExcelExport,
  TablePagination,
  ButtonExport,
  EmailGroup,
  DragDropConfigExportTemplate,
  ModalWithItem,
} from '../../../../components/common';
import { tabelColumnUnbilledTransactions, sortUnbilledTransactions } from '../../constants';
import { getUnbilledTransactions, getAllUnbilledTransactions } from '../../actions';
import { makeGetListUnbilledTransactions, makeGetListAllUnbilledTransactions } from '../../selectors';
import {
  getPageTotalCount,
  parseToMutationRequestPostMethod,
  blobToFile,
  validateEmail,
  blobToCSVFile,
  configOutputTemplateByType,
} from '../../../../utils/utils';
import convertJson2Sheet from '../../../../utils/ExcelHelper/exportExcelFile';
import convertJson2Pdf from '../../../../utils/PdfHelper/exportPdfFile';
import { PAGE_SIZE_DOWNLOAD } from '../../../../utils/constants';

let tableColumnsOutput = null;

class UnbilledTransactions extends Component {
  state = {
    isActivePdf: false,
    page: 0,
    size: 20,
    filter: {},
    sort: '',
    sorted: {},
    totalCount: null,
    isSearching: false,
    listUnbilledTransactions: [],
  };

  buttonRef = React.createRef();

  static getDerivedStateFromProps(props, state) {
    return {
      listUnbilledTransactions: props.listUnbilledTransactions,
      totalCount: getPageTotalCount({ ...state, items: props.listUnbilledTransactions }),
    };
  }

  componentDidMount() {
    const {
      permissions: { modeGetUnbilledTransactionReport },
    } = this.props;
    if (modeGetUnbilledTransactionReport) {
      this.doGetReportUnbilledTransactions();
      this.doGetOutputTemplateByType();
    }
  }

  onSortColumn = (sortCol, sortDir) => {
    this.setState({ sorted: { sortCol, sortDir } }, () => {
      this.doGetReportUnbilledTransactions();
    });
  };

  onPageChange = page => {
    this.setState({ page }, () => this.doGetReportUnbilledTransactions());
  };

  onSizeChange = size => {
    this.setState({ size, page: 0 }, () => this.doGetReportUnbilledTransactions());
  };

  onHandleSubmitSearch = filter => {
    this.setState({ filter: { ...filter }, page: 0 }, () => {
      this.doGetReportUnbilledTransactions();
    });
  };

  doGetReportUnbilledTransactions = () => {
    const { filter, page, size, sorted } = this.state;
    const { getUnbilledTransactions } = this.props;
    const payload = {
      page: page + 1,
      size,
      filter,
      sort:
        !isEmpty(sorted) && sortUnbilledTransactions[sorted.sortCol]
          ? sortUnbilledTransactions[sorted.sortCol][sorted.sortDir]
          : null,
    };
    this.setState({ isSearching: true });
    getUnbilledTransactions(payload, () => {
      this.setState({ isSearching: false });
    });
  };

  doGetAlllistUnbilledTransactions = cb => {
    const { filter, sorted } = this.state;
    const { getAllUnbilledTransactions } = this.props;
    const payload = {
      page: 1,
      size: PAGE_SIZE_DOWNLOAD,
      filter,
      sort: !isEmpty(sorted) ? sortUnbilledTransactions[sorted.sortCol][sorted.sortDir] : null,
    };
    getAllUnbilledTransactions(payload, () => {
      if (cb) cb();
    });
  };

  onChangeSwitch = () => {
    const { isActivePdf } = this.state;
    this.setState({ isActivePdf: !isActivePdf });
  };

  onExport = () => {
    this.doGetAlllistUnbilledTransactions(() => {
      const { isActivePdf } = this.state;
      if (isActivePdf) {
        const { listAllUnbilledTransactions, t } = this.props;
        convertJson2Pdf({
          data: listAllUnbilledTransactions,
          t,
          title: t('reportPage:sidebar.unbilledTransactions').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.unbilledTransactions')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          columnsTable: tableColumnsOutput,
        });
      } else {
        this.buttonRef.current.click();
      }
    });
  };

  sendEmail = ({ subject, emailBody }) => {
    this.doGetAlllistUnbilledTransactions(() => {
      const { listAllUnbilledTransactions, t, uploadMultiPartFiles } = this.props;
      const { emails, isActivePdf } = this.state;

      const query = `{"query": "mutation{sendReport(input: ${parseToMutationRequestPostMethod(
        {
          emailAddress: emails.join(', '),
          type: 'GET_UNBILLED_TRANSACTION_REPORT',
          subject: subject || `Embrix Report ${t('reportPage:sidebar.unbilledTransactions')}`,
          emailBody,
        },
        ['type']
      )})}"}`;
      const formData = new FormData();

      if (!isActivePdf) {
        formData.append(
          'file',
          blobToCSVFile({
            fileName: `${t('reportPage:sidebar.unbilledTransactions')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}.csv`,
            data: listAllUnbilledTransactions,
            t,
            columns: tableColumnsOutput,
            listOptionFields: { serviceType: 'serviceType', accountType: 'accountType', status: 'subscriptionStatus' },
          })
        );
      } else {
        const pdfFile = convertJson2Pdf({
          data: listAllUnbilledTransactions,
          t,
          title: t('reportPage:sidebar.unbilledTransactions').toLocaleUpperCase(),
          fileName: `${t('reportPage:sidebar.unbilledTransactions')
            .toLocaleLowerCase()
            .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`,
          isFile: true,
          columnsTable: tableColumnsOutput,
        });
        formData.append(
          'file',
          blobToFile(
            pdfFile,
            `${t('reportPage:sidebar.unbilledTransactions')
              .toLocaleLowerCase()
              .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`
          )
        );
      }

      formData.append('graphql', query);
      // formData.append('file', blobToFile(pdfFile, 'attachment'));
      uploadMultiPartFiles(
        formData,
        res => {
          if (res && res.success) {
            if (res.success) this.setState({ emails: [] });
          }
        },
        true
      );
    });
  };

  onChangeEmail = tags => {
    let isEmail = true;
    if (tags && tags.length) {
      tags.forEach(email => {
        if (!validateEmail(email)) {
          isEmail = false;
        }
      });
    }
    if (!isEmail) return '';

    return this.setState({ emails: tags });
  };

  doGetOutputTemplateByType = () => {
    const { getOutputTemplateByType, t } = this.props;
    getOutputTemplateByType('UNBILLED_TRANSACTIONS_REPORT', ({ success, data }) => {
      if (success && data) {
        this.setState({
          exportColumnsSave: configOutputTemplateByType({
            columns: tabelColumnUnbilledTransactions,
            data,
            t,
          }),
          idOutputTemplate: data?.id,
          typeOutputTemplate: data?.type,
        });
      }
    });
  };

  onHandleSaveConfig = columns => {
    const { saveOutputTemplateByType } = this.props;
    const { idOutputTemplate, typeOutputTemplate } = this.state;
    const payload = {
      id: idOutputTemplate,
      type: typeOutputTemplate,
      source: columns.sourceFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
      target: columns.targetFields.items.map((val, index) => {
        return { name: val.name, index: index + 1 };
      }),
    };

    saveOutputTemplateByType(payload, ({ success }) => {
      if (success) {
        this.doGetOutputTemplateByType();
        this.setState({ exportColumnsSave: columns, isOpenModalExportConfig: false });
      }
    });
  };

  onToggleModalExportConfig = () => {
    const { isOpenModalExportConfig } = this.state;
    this.setState({ isOpenModalExportConfig: !isOpenModalExportConfig });
  };

  render() {
    const {
      isSearching,
      isActivePdf,
      sorted,
      page,
      size,
      totalCount,
      listUnbilledTransactions,
      emails,
      exportColumnsSave,
      isOpenModalExportConfig,
    } = this.state;
    const {
      listAllUnbilledTransactions,
      t,
      permissions: { modeGetUnbilledTransactionReport, modeDownloadReport, modeGetMailReport },
    } = this.props;
    if (!modeGetUnbilledTransactionReport) return '';
    const exportColumns = exportColumnsSave || {};
    tableColumnsOutput = exportColumns?.targetFields?.items || [];
    return (
      <div className="col-md-12">
        <PageTitle
          linkTo={RouteNames.report.path}
          titleBtn="back"
          items={[
            { name: t('label.report'), url: RouteNames.report.path },
            { name: t('reportPage:sidebar.unbilledTransactions') },
          ]}
        />
        <br />
        <div className="card card-statistics mb-30">
          <TitleFrom title={t('reportPage:sidebar.unbilledTransactions')} />
          <div className="col-md-12 mb-30">
            <div className="card-body">
              <div className="pl-2">
                <UnbilledTransactionsSearchForm onSubmit={this.onHandleSubmitSearch} />
              </div>
              <div>
                <div className="mt-3 col-md-12 row mb-4 pt-3 pb-3">
                  <button
                    type="submit"
                    onClick={this.onToggleModalExportConfig}
                    className="button x-small mr-2 btn-config"
                  >
                    {/* {t('label.outputConfig')} */}
                    <i className="ti-list" />
                  </button>
                  {!!modeDownloadReport && (
                    <div className="ml-auto mt-2 mb-auto mr-3">
                      <SwitchExport
                        onChange={this.onChangeSwitch}
                        wrapperClass={isActivePdf ? 'switch-active' : 'switch-non-active'}
                        title={t('label.excel')}
                        checked={isActivePdf}
                        rightTitle={t('label.pdf')}
                      />
                    </div>
                  )}
                  {!!modeDownloadReport && (
                    <>
                      <ButtonExport onExport={this.onExport} />
                      <ExcelExport
                        element={<button type="button" className="display-none" ref={this.buttonRef} />}
                        nameSheet={t('reportPage:sidebar.unbilledTransactions').toLocaleUpperCase()}
                        multiDataSet={convertJson2Sheet({
                          data: listAllUnbilledTransactions,
                          t,
                          title: t('reportPage:sidebar.unbilledTransactions').toLocaleUpperCase(),
                          columnsTable: tableColumnsOutput,
                        })}
                        fileName={`${t('reportPage:sidebar.unbilledTransactions')
                          .toLocaleLowerCase()
                          .replace(/ /g, '_')}_${moment(new Date()).format('YYYY_MM_DD')}`}
                      />
                    </>
                  )}
                  {modeGetMailReport !== 0 && (
                    <EmailGroup
                      emails={emails}
                      onChangeEmail={this.onChangeEmail}
                      sendEmail={this.sendEmail}
                      data={listUnbilledTransactions}
                    />
                  )}
                </div>
                <DataTable
                  columns={tableColumnsOutput}
                  data={listUnbilledTransactions && listUnbilledTransactions.length ? listUnbilledTransactions : []}
                  onSort={this.onSortColumn}
                  sorted={sorted}
                  isLoading={isSearching}
                  isFixedHeaderTable
                />
              </div>
            </div>
          </div>
        </div>
        <div className="mb-30">
          <TablePagination
            pageNumber={page}
            pageSize={size}
            totalCount={totalCount}
            onPageChange={this.onPageChange}
            onSizeChange={this.onSizeChange}
          />
        </div>
        <ModalWithItem
          onToggle={this.onToggleModalExportConfig}
          isOpen={isOpenModalExportConfig}
          wrapperClass="modal-config"
        >
          <div className="col-md-12 d-flex">
            <div className="column-config" onClick={this.onToggleModalExportConfig} />
            <div className="body-config">
              <DragDropConfigExportTemplate
                onHandleSave={this.onHandleSaveConfig}
                exportColumns={exportColumns}
                onToggle={this.onToggleModalExportConfig}
              />
            </div>
          </div>
        </ModalWithItem>
      </div>
    );
  }
}

UnbilledTransactions.propTypes = {
  getUnbilledTransactions: PropTypes.func,
  getAllUnbilledTransactions: PropTypes.func,
  listAllUnbilledTransactions: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.any),
    PropTypes.objectOf(PropTypes.any),
  ]),
};

UnbilledTransactions.defaultProps = {
  getUnbilledTransactions: () => {},
  getAllUnbilledTransactions: () => {},
  listAllUnbilledTransactions: [],
};

const mapStateToProps = createStructuredSelector({
  listUnbilledTransactions: makeGetListUnbilledTransactions() || [],
  listAllUnbilledTransactions: makeGetListAllUnbilledTransactions() || [],
});

export default withTranslation('common')(
  connect(mapStateToProps, {
    getUnbilledTransactions,
    getAllUnbilledTransactions,
    uploadMultiPartFiles,
    saveOutputTemplateByType,
    getOutputTemplateByType,
  })(UnbilledTransactions)
);
